
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Ashworth',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/Ashworth.vue